interface Column<T> {
  headerName: string;
  field: keyof T;
}

export const exportToCsv = <T extends Record<string, any>>(
  filename: string,
  rows: T[],
  columns: Column<T>[]
) => {
  if (!rows.length) return;
  const header = columns.map((col) => col.headerName).join(',');
  const csv = [
    header,
    ...rows.map((row) => columns.map((col) => JSON.stringify(row[col.field] ?? '')).join(',')),
  ].join('\n');
  const blob = new Blob([csv], { type: 'text/csv' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(link.href);
};
